/* eslint-disable react/require-default-props */
import React from 'react';

import BiddingNoContentError from 'components/atoms/bidding_no_content_error';
import ChatbotInput from 'components/atoms/chatbot_input';
import ChatbotMessage from 'components/atoms/chatbot_message';
import LoadingBidding from 'components/atoms/loading_bidding';
import ChatbotTypingRow from 'components/molecules/chatbot_typing_row';

import type { BiddingChatSession } from 'hooks/useBiddingChatSession';
import type { BiddingChatMessageTypes } from 'store/modules/bidding_chat/types';

import tabId from 'services/tabId';

interface BiddingChatConversationProps {
  session: BiddingChatSession;
  welcomeMessage: BiddingChatMessageTypes;
  source?: string;
  footerFeedbackAction?: React.ReactNode;
}

const BiddingChatConversation: React.FC<BiddingChatConversationProps> = ({
  session,
  welcomeMessage,
  source = 'pergunte-ao-edital',
  footerFeedbackAction,
}) => {
  const {
    messages,
    isLoadingChat,
    isLoadingMessage,
    hasNoContent,
    hasFetchMessagesError,
    messagesRef,
    inputRef,
    sendMessage,
  } = session;
  const tab = tabId();

  return (
    <div className="modal-body p-0 chatbot">
      <div className="chatbot-body">
        {hasNoContent && (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="position-relative">
              <BiddingNoContentError
                title="Identificamos um problema com este edital e não será possível utilizar a ferramenta."
                subtitle="Fale com um consultor."
              />
            </div>
          </div>
        )}

        {!isLoadingChat && !hasNoContent && (
          <div className="chatbot-messages" ref={messagesRef}>
            <ChatbotMessage message={welcomeMessage} source="chat" firstMessage />
            {messages?.map((message, index) => (
              <ChatbotMessage
                message={message}
                source="bidding_chat"
                key={
                  message.id != null
                    ? String(message.id)
                    : `assistant-msg-${tab}-${message.created_at}-${index}`
                }
              />
            ))}
            {isLoadingMessage && <ChatbotTypingRow variant="bidding_chat" />}
            {hasFetchMessagesError && (
              <div className="alert alert-secondary p-2 text-center my-2 ml-2">
                Ocorreu um erro. Faça a pergunta novamente.
              </div>
            )}
          </div>
        )}

        {isLoadingChat && (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="position-relative">
              <LoadingBidding
                title="Acessando os arquivos da licitação."
                subtitle="Aguarde, isso pode levar alguns segundos."
              />
            </div>
          </div>
        )}
      </div>

      {!isLoadingChat && (
        <ChatbotInput
          componentRef={inputRef}
          isLoading={isLoadingMessage}
          sendMessage={sendMessage}
          source={source}
          footerFeedbackAction={footerFeedbackAction}
        />
      )}
    </div>
  );
};

export default BiddingChatConversation;
